/**
 * Expand widget on click on title / button
 */

$('.js-widgets').on('click', '.widget__head', function(evt) {
	evt.preventDefault();
	
	$(this)
		.parent()
		.find('.widget__body')
			.slideToggle()
		.end()
		.toggleClass('is-expanded');
});
